module.exports = __webpack_public_path__ + "static/img/gm_open01.e7cfc8c8.png";